import React, { useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';

function SpotDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Rediriger vers la page principale avec le paramètre spot
    // Cela ouvrira la modale de détails au lieu d'afficher cette page
    const detailsParam = searchParams.get('details');
    if (detailsParam === 'true') {
      navigate(`/?spot=${id}`, { replace: true });
    } else {
      // Si pas de paramètre details, rediriger vers la carte principale
      navigate('/', { replace: true });
    }
  }, [id, searchParams, navigate]);

  // Afficher un loader pendant la redirection
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="text-gray-500">Redirection...</div>
      </div>
    </div>
  );
}

export default SpotDetailsPage;
